import styled from "styled-components";

export const DashboardCardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  margin: 5px;

  @media only screen and (max-width: 400px) {
    justify-content: center;
  }
`;